"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BulkDeleteContactsSocketEvent = exports.MAX_CONTACTS_PER_BULK_DELETE = void 0;
exports.MAX_CONTACTS_PER_BULK_DELETE = 50_000;
var BulkDeleteContactsSocketEvent;
(function (BulkDeleteContactsSocketEvent) {
    BulkDeleteContactsSocketEvent["JoinRoom"] = "bulkDeleteContacts:joinRoom";
    BulkDeleteContactsSocketEvent["LeaveRoom"] = "bulkDeleteContacts:leaveRoom";
    BulkDeleteContactsSocketEvent["Progress"] = "bulkDeleteContacts:progress";
    BulkDeleteContactsSocketEvent["Completed"] = "bulkDeleteContacts:completed";
    BulkDeleteContactsSocketEvent["Failed"] = "bulkDeleteContacts:failed";
})(BulkDeleteContactsSocketEvent || (exports.BulkDeleteContactsSocketEvent = BulkDeleteContactsSocketEvent = {}));
